import {strengthColor} from '@/lib/strengthColor';
import { Component, Vue, Prop } from 'vue-property-decorator';



@Component
export default class Strengthmeter extends Vue {

  @Prop({ default: 0 }) readonly strength!: number;
  @Prop({ default: false }) readonly didnotmatch!: boolean;


  get label(){

    if (this.strength === 0) return 'Weak (min 8 symbols with number, upper & lower case letters)';

    if (this.didnotmatch) return 'Passwords do not match';

    if (this.strength === 1) return 'Medium (add special symbol or make length at least 12)';

    if (this.strength === 2) return 'Strong (add special symbol and make length at least 12)';

    if (this.strength >= 3) return 'Very Strong';

    return ''

  }


  get color(){
    return strengthColor(this.strength, this.didnotmatch)
  }


  
  
}